export default __webpack_public_path__ + "static/027-eb5e81dcab834ed516227154d685f550.png";